<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import TemplateRequest from 'Modules/contacard/produto/templates/TemplateRequest';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import LocalSessionMixin from '@/app/arch/mixins/LocalSessionMixin';
import PadraoTemplateColumnVue from './PadraoTemplateColumn.vue';

export default {
  name: 'ProdutoTemplateCrudList',
  extends: CrudListVue,
  mixins: [LocalSessionMixin],
  data: (vm) => ({
    requestClass: TemplateRequest,
    editRoute: 'template.edit',
    actionOptions: [
      {
        icon: 'mdi-content-copy',
        name: 'Replicar template',
        handler: (row) => {
          vm.setSessionItem('templateId', row.id);
          vm.goTo('template.reply', { templateId: row.id });
        },
      },
      {
        icon: 'mdi-apps',
        name: 'Listar produtos',
        handler: (row) => {
          vm.setSessionItem('templateId', row.id);
          vm.goTo('produtoTemplate.list', { templateId: row.id });
        },
      },
    ],
    headers: [
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Descrição',
        value: 'dscTemplate',
      },
      {
        text: 'Código Empresa',
        value: 'idEmpresa',
      },
      {
        text: 'Padrão',
        value: 'indPadrao',
        component: PadraoTemplateColumnVue,
      },
      {
        text: 'Última atualização',
        value: 'updatedDate',
        component: DataTableDateColumnVue,
      },
    ],
  }),
};
</script>
